import { types } from 'mobx-state-tree';

export interface BalancesSingleItemProps {
  amount: number;
  date: number;
}

export const BalancesSingleItem = types.model({
  amount: types.number,
  date: types.number,
});
